<template>
  <div class="flex">
    <div class="info-value mr-1">
      {{ estimated }}
    </div>
    <div class="info-key">
      {{ $t("message.votesIn") }}
    </div>
  </div>
</template>

<script>
import { percentage } from "@/filters";

const props = {
  estimatedVotes: {
    type: Object,
    required: false,
  },
  precinctsReporting: {
    type: Object,
    required: false,
  },
  totalVotes: {
    type: Number,
    required: false,
  },
};

const computed = {
  estimated() {
    let perc = this.totalVotes / this.estimatedVotes.estimated_votes_mid;
    if (this.totalVotes === 0) {
      return "0%";
    } else if (perc < 0.01) {
      return "< 1%";
    } else if (perc > 0.99) {
      return `> 99%`;
    } else {
      perc = percentage(perc);
      return `${perc}`;
    }
  },
};

export default {
  props,
  computed,
};
</script>
